import React, { useEffect, useState } from "react";
import { useUnidades } from "./../hooks/test/useUnidades";
import es from "date-fns/locale/es";
import { Box, InputLabel, FormControl, Select, MenuItem } from "@mui/material";
import DatePicker, { registerLocale } from "react-datepicker";

// Registrar locale
registerLocale("es", es);

const tipoUnidad = [
  { tipo_unidad_id: 1, descripcion: "Camiones" },
  { tipo_unidad_id: 7, descripcion: "Cajas" },
];

const Filtros = ({ config = [], valores = [], onChange }) => {
  const { getNegocios } = useUnidades();
  const [negocios, setNegocios] = useState([]);
  const [range, setRange] = useState([
    valores.fechaI ? new Date(valores.fechaI) : null,
    valores.fechaF ? new Date(valores.fechaF) : null,
  ]);
  const [startDate, endDate] = range;

  // Cargar negocios
  useEffect(() => {
    const fetchNegocios = async () => {
      try {
        const resp = await getNegocios();
        if (resp.ok) setNegocios(resp.negocios);
      } catch (err) {
        console.error("Error cargando negocios:", err);
      }
    };
    fetchNegocios();
  }, []);

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: "#f5f5f5",
        borderRadius: 2,
        maxWidth: 400,
        margin: "auto",
      }}
    >
      {config.map((campo) => {
        switch (campo) {
          case "negocio":
            return (
              <FormControl fullWidth sx={{ mb: 2 }} key={campo}>
                <InputLabel>Cliente</InputLabel>
                <Select
                  value={valores.negocioId || ""}
                  onChange={(e) => onChange("negocio", e.target.value)}
                  label="Cliente"
                >
                  {negocios.map((x) => (
                    <MenuItem key={x.negocio_id} value={x.negocio_id}>
                      {x.negocio_nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );

          case "tipo_unidad":
            return (
              <FormControl fullWidth sx={{ mb: 2 }} key={campo}>
                <InputLabel>Tipo</InputLabel>
                <Select
                  value={valores.tipoUnidadId || ""}
                  onChange={(e) => onChange("tipo_unidad", e.target.value)}
                  label="Centro"
                >
                  {tipoUnidad.map((x) => (
                    <MenuItem key={x.tipo_unidad_id} value={x.tipo_unidad_id}>
                      {x.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );

          case "fechas":
            return (
              <Box fullWidth key={campo} sx={{ mb: 2 }}>
                <Box>Rango</Box>
                <DatePicker
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    const [start, end] = update;
                    setRange([start, end]);
                    if (start) onChange("fechaI", start);
                    if (end) onChange("fechaF", end);
                  }}
                  className="form-control"
                  dateFormat="yyyy-MM-dd"
                  locale="es"
                  minDate={null}
                  maxDate={
                    startDate
                      ? new Date(
                          Math.min(
                            new Date().getTime(),
                            startDate.getTime() + 7 * 24 * 60 * 60 * 1000
                          )
                        )
                      : new Date()
                  }
                  withPortal
                  isClearable={false}
                />
              </Box>
            );
          default:
            return null;
        }
      })}
    </Box>
  );
};

export default Filtros;
